import React from 'react';
import { Tabs } from 'antd';
import InventoryStock from './inventoryStock';
import WarehouseWriteoffReport from 'components/warehouse_writeoff_report';

const Inventory = () => (
  <Tabs
    defaultActiveKey="stock"
    items={[
      {
        key: 'stock',
        label: 'Инвентарь',
        children: <InventoryStock />,
      },
      {
        key: 'report',
        label: 'Отчёт',
        children: <WarehouseWriteoffReport personal />,
      },
    ]}
  />
);

export default Inventory;
